import React from 'react';
// import Wrp from '../../hoc/Wrp/Wrp';
import {
    isSet,
    getSelectedValueBasedOnField,
    convertStrToArrWithSeparator
} from '../../Utils/CommonFunctions';
import {API_URL} from '../../Global/Constants';

// import SubformTypeForm from '../../Containers/LayoutContainer/LayoutForms/SubformTypeForm';
// import SectionTypeForm from '../../Containers/LayoutContainer/LayoutForms/SectionTypeForm';
import jQuery from "jquery";
// import SwitchItems from '../../Components/FormBuilder/Builder/FormInputs/SwitchItems';
// import FormInputFields from '../FormInputFields';
// import { ErrorBlock } from '../../hoc/FormInput';

  //EXTRACT STYLES TAG CSS 
  export const extractStylesAsObjects = str => {
    const style = {};
    str.split(";").forEach(el => {
      if(el.toString().trim()!==''){
        const [property, value] = el.split(":");
        if (!property) return;
    
        const formattedProperty = formatStringToCamelCase(property.trim());
        style[formattedProperty] = value.toString().trim();
      }
    });
    return style;
  }
    //Format XML Value to Pretty formatted
    export const convertToPrettyXml = (xml)=>
    {
      var formatted = '';
      var reg = /(>)(<)(\/*)/g;
      xml = xml.replace(reg, '$1\r\n$2$3');
      var pad = 0;
      jQuery.each(xml.split('\r\n'), function(index, node) {
          var indent = 0;
          if (node.match( /.+<\/\w[^>]*>$/ )) {
              indent = 0;
          } else if (node.match( /^<\/\w/ )) {
              if (pad != 0) {
                  pad -= 1;
              }
          } else if (node.match( /^<\w[^>]*[^\/]>.*$/ )) {
              indent = 1;
          } else {
              indent = 0;
          }
          var padding = '';
          for (var i = 0; i < pad; i++) {
              padding += '  ';
          }
          formatted += padding + node + '\r\n';
          pad += indent;
      });
      return formatted;
  }


  //FORMAT  HYPEN FORMAT PROPERTIES STYLES TO CAMELCASE
  export const formatStringToCamelCase = str => {
    const splitted = str.split("-");
    if (splitted.length === 1) return splitted[0];
    return (
      splitted[0] +
      splitted
        .slice(1)
        .map(word => word[0].toUpperCase() + word.slice(1))
        .join("")
    );
  }

  

export const extractFieldValue = (dynamicVar,entries)=>{
  let returnValue = null;
  const replace = entries.replace(/("|')/g, "").replace(/\[([^\]]+)\]/g, '.$1');
  // dot or sq brackets to dot
  const entriesInArr = convertStrToArrWithSeparator(replace,'.');
  //split with dot seprator

  // Object.entries(dynamicVar).map(([key, value]) => {
    // stg = stg.replace(key,'dynamicVar["'+key+'"]');
  // });
  // dots.replace(/\.(.+?)(?=\.|$)/g, (m, s) => `[${s}]`)
  let updatedEntriesInArr = [];
  try{
     
  entriesInArr.map((ent)=>{
    if(Object.keys(dynamicVar).indexOf(ent)!==-1){
      updatedEntriesInArr.push('dynamicVar["'+ent+'"]');
    }else{
      updatedEntriesInArr.push('"'+ent+'"');
    }
  })
  }catch(e){

  }
 
  // console.log('entriesInArr',entriesInArr,updatedEntriesInArr);
  const entriesBackToStr = updatedEntriesInArr.join('.');
  const finalStr = entriesBackToStr.replace(/\.(.+?)(?=\.|$)/g, (m, s) => `[${s}]`);
  // console.log('finalStr12',finalStr,dynamicVar);
  try{
    if(finalStr.indexOf('dynamicVar')!==-1){
      returnValue = eval(finalStr)
    }
  }catch(e){

  }
  // console.log('extractFieldValue',entries,finalStr,returnValue,dynamicVar);
  return returnValue;
  
}
 
  // //GET FIELDS PROPS ELEMENT
  // export const getFieldsPropsElement = (attributes,paramObj)=>{
  //   const {type,defProps} = paramObj;
  //   let attribsName = (attributes.hasOwnProperty('name')===true)?attributes.name:'';
  //   const {modType,fieldGroups,formFields} = defProps;
  //   let element = null;
  //   fieldGroups.map((section) => {
  //       if(section.type!=='subform'){
  //           section.data.map((field,itemIndex)=>{
  //               if(field.label.blocks[0].text.toLowerCase()===attribsName.toLowerCase()){ 
  //                 const fieldObj = {
  //                   section_index:section.section_index,
  //                   itemIndex:field.itemIndex,
  //                   modType:modType,
  //                   item:{
  //                    ...field,
                    
  //                    modType:modType
  //                  },
  //                }
  //                   let appendAttr ={};
  //                   if(isSet(attributes.class,'')!==''){
  //                     appendAttr = {
  //                       className:isSet(attributes.class,'')
  //                     }
  //                   }
  //                   console.log()
  //                   element =  <SwitchItems 
  //                                 {...defProps} 
  //                                 key={itemIndex}
  //                                 fieldObj={fieldObj}
  //                                 item={{...field,displayType:isSet(attributes.displaytype,''),customAttr:isSet(attributes,''),modType:modType}}
  //                                 inputBlockOnly={true}
  //                                 {...appendAttr}
  //                                 onlyInputComponent={true}
  //                                 errorBlock={true}
  //                                 isLabel={isSet(attributes.withlabel,true) === 'false' ? false : Boolean(isSet(attributes.withlabel,true))}
  //                                 withoutBlock={isSet(attributes.inputOnly,true) === 'false' ? false : Boolean(isSet(attributes.inputOnly,true))}
  //                                 section={section} />
                    
  //               }
  //           }) 
  //       }
  //     });
  //   const indexing = formFields.findIndex((i)=>attribsName.toLowerCase()===i.label.toLowerCase());
  //   if(indexing!==-1){
  //     element = <>
      
  //               <FormInputFields {...formFields[indexing]} />
  //               <ErrorBlock message={isSet(formFields[indexing].error,'')}/>    
  //               </>
  //   }
  //   // console.log('formFields',formFields,indexing);
  //   return element;  
  // }


export const getAttribute = (attributes,name,def='')=>{
  return (attributes.hasOwnProperty(name)===true)?attributes[name]:def;
}
export const isAttrHasProperty = (attributes,name)=>{
  return attributes.hasOwnProperty(name);
}

export const formatVal = (attribs,value)=>{
  if(isAttrHasProperty(attribs,'precision') && value !== null){
      return Number(value).toFixed(getAttribute(attribs,'precision'));
  }
  return value;
}

export const getOutputFieldsElement = (attributes,paramObj)=>{
  const {loopData,defProps,dataTable,dynamicVar} = paramObj;
  const {fieldGroups,formFields,outputResponse} = defProps;
  // console.log('paramObj',paramObj);
    let element =null;
    let attribsName   = (attributes.hasOwnProperty('name')===true)?attributes.name:'';
    let fieldType     = (attributes.hasOwnProperty('type')===true)?attributes.type:'';
    let attribsValue  = (attributes.hasOwnProperty('value')===true)?attributes.value:'';
    let defaultValue  = (attributes.hasOwnProperty('defaultvalue')===true)?attributes.defaultvalue:'';
    const value       = isSet(attribsName,attribsValue);
  // console.log('valuevalue',value);
      // console.log('valuevalue - outputResponse',dynamicVar,value,attributes,fieldType,element);  
      if(isSet(extractFieldValue(dynamicVar,value),null)!==null){ 
        element = isSet(extractFieldValue(dynamicVar,value),isSet(defaultValue,''));
        // console.log('formatVal',formatVal(attributes,element),element);
        // console.log('text - key',value,attributes,loopData);
        
        // Check if data-source is asset and construct URL
        if(isSet(attributes['data-source'], '') === 'asset'){
          element = API_URL+'files/download?fileId='+element;
        }
        
          if(isSet(fieldType,'')==='image'){
            let imgUrl = isSet(attributes['data-source'], '') === 'asset' ? element : API_URL+'files/download?fileId='+element;
            if(isSet(attributes.isexternal,'false')==='true'){
              imgUrl = element;
            }
            element = React.createElement('img', {src:imgUrl,...attributes,style:{width:'100%',minWidth:'100px',maxWidth:'100px',overflow:'hidden'}})
          }else{
            element = formatVal(attributes,element);
          }
      }else{
        Object.entries(isSet(loopData,{})).map(([key, Data]) => {
          const dataTableName =  isSet(dataTable,'').toLowerCase()+'.';
          const replacingParent = value.toLowerCase().replace(dataTableName, "");
          // console.log('Image - key',key,value,attributes);
           if(key.toLowerCase()===replacingParent.replace(' ','_') || key.toLowerCase()===replacingParent){
             if(key.indexOf('image')!==-1){
               let imgUrl = API_URL+'files/download?fileId='+Data;
               if(isSet(attributes.isexternal,'false')==='true'){
                 imgUrl = Data;
               }
               element = React.createElement('img', {src:imgUrl,...attributes,style:{width:'100%',minWidth:'100px',maxWidth:'120px',overflow:'hidden'}})
             }else{
                // console.log('Data',Data,defaultValue);
               element = isSet(Data,isSet(defaultValue,''));
              //  console.log('formatVal',formatVal(attributes,element),element);
               
               // Check if data-source is asset and construct URL
               if(isSet(attributes['data-source'], '') === 'asset'){
                 element = API_URL+'files/download?fileId='+element;
               }
               
               element = formatVal(attributes,element);
             }
             
           }
         })
         fieldGroups.forEach((section) => {
           if(section.type!=='subform'){
                section.data.forEach((field)=>{
                   if(field.label.blocks[0].text.toLowerCase()===value.toLowerCase()){ 
                       element = isSet(getSelectedValueBasedOnField(field),isSet(defaultValue,''));
                       element = formatVal(attributes,element);
                   }
               }) 
           }
         });
      }
      const indexing = isSet(formFields,[]).findIndex((i=>i.label.toLowerCase()===attribsName.toLowerCase()));
      if(indexing!==-1){
        element = isSet(formFields,[])[indexing].value;
      }
      // console.log('outputResponse',outputResponse,attribsName);
      
      // const outputIndexing = isSet(outputResponse,[]).findIndex((i=>i.label.toLowerCase()===attribsName.toLowerCase()));
      // console.log('outputResponse',outputResponse,element,value);
      if(isSet(outputResponse,null)!==null && element===null){
        element = extractFieldValue(outputResponse,value);
        
        // Check if data-source is asset and construct URL
        if(isSet(attributes['data-source'], '') === 'asset'){
          element = API_URL+'files/download?fileId='+element;
        }
        
        try{
           if(isSet(fieldType,'')==='image'){
            let imgUrl = isSet(attributes['data-source'], '') === 'asset' ? element : API_URL+'files/download?fileId='+element;
            if(isSet(attributes.isexternal,'false')==='true'){
              imgUrl = element;
            }
            element = React.createElement('img', {src:imgUrl,...attributes,style:{width:'100%',minWidth:'100px',maxWidth:'100px',overflow:'hidden'}})
          }
           
        }catch(e){

        }
       
      }
     
  return isSet(element,defaultValue);  
}



 export const isValidJson = (value) => {
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      try {
        JSON.stringify(value);
        return true;
      } catch (e) {
        return false;
      }
    }
    return false;
  };


  export const  flattenPathObject = (map, pathString) =>{
    const path = pathString.split('.');
    let pathMap =['item'];
     path.forEach((i)=>{
      pathMap.push("['"+i+"']");
    })
    let flatmap = [];
      flatmap = isSet(map,[]).flatMap(item => {
        try{
          return isSet(eval(pathMap.join('')),[]); // Use eval to access the dynamic path
        }catch(e){
          return [];
        }
      });
    return flatmap;
  }

  //ASSIGN/REPLACE VARIABLE TO VALUES 
  export const injectVariableValues = (itemData,attributes,elmtParams,displayContent)=>{
      const startingIndex = itemData.indexOf('${');
      const endingIndex = itemData.indexOf('}');
      if (itemData.indexOf('${') !== -1 && itemData.indexOf('}') !== -1){
        let variableValue = itemData.substring((startingIndex), endingIndex);
        variableValue = variableValue.replace(/{/gi,'');
        variableValue = variableValue.replace('$','');
        variableValue = variableValue.replace(/}/gi,'');
        const replacingValue = getOutputFieldsElement({...attributes,value:variableValue.trim()},elmtParams);
        displayContent = itemData.replace('${'+variableValue+'}',replacingValue);
      }
      return displayContent;
    }


  export const  sortByDataList = (array, sort, order = 'asc') => {
    const keys = sort.split(',').map(k => k.trim());
  
    return array.sort((a, b) => {
      for (const key of keys) {
        const aVal = a[key];
        const bVal = b[key];
  
        if (aVal !== bVal) {
          if (order.toLowerCase() === 'asc') {
            return aVal - bVal;
          } else if (order.toLowerCase() === 'desc') {
            return bVal - aVal;
          }
        }
      }
      return 0; // All keys equal
    });
  };


  export const  buildElementString = (node) => {
      if (node.type === 'text') {
          // Return text nodes directly
          return node.data || '';
      }
  
      if (node.type === 'tag') {
          // Start the tag
          const attributes = Object.entries(node.attribs || {})
              .map(([key, value]) => `${key}="${value}"`)
              .join(' ');
  
          // Build children recursively
          const children = (node.children || [])
              .map(buildElementString)
              .join('');
  
          return `<${node.name}${attributes ? ` ${attributes}` : ''}>${children}</${node.name}>`;
      }
  
      return '';
  };

  // Function to split function name and arguments
  export const splitFunctionAndArgs = (value)=> {
    const index = value.indexOf('(');
    if (index !== -1) {
      const functionName = value.slice(0, index).trim();
      const args = value.slice(index + 1, -1).trim();
      return [functionName, args];
    } else {
      return [value.trim(), null];
    }
  }

export const scopeCssWithClass = (prefClassName,className, cssString, isPreview = false) => {
    // Remove any leading/trailing spaces
  //   const trimmedClass = className.trim();
  // console.log('cssString',cssString);
  //   // Regex to match CSS selectors (before each `{`)
  //   return cssString.replace(/([^\{\}]+)\s*\{/g, (match, selector) => {
  //       // Split multiple selectors (e.g., input, select)
  //       const scopedSelectors = selector
  //           .split(',')
  //           .map(s => `${trimmedClass}${s.trim()}`)
  //           .join(', ');
  //       return `${scopedSelectors} {`;
  //   });


  // const noComments = isSet(cssString,'').toString().replace(/\/\*[\s\S]*?\*\//g, '');
  // // console.log('noComments',noComments);
  // return isSet(noComments,'').toString().replace(/([^\{\}]+)\s*\{/g, (match, selector) => {
  //   const scopedSelectors = selector
  //     .split(',')
  //     .map(s => {
  //       let trimmed = s.trim();

  //       // If it already starts with .scm, don't double prefix
  //       if (trimmed.startsWith(`#${prefClassName}`)) {
  //         return trimmed;
  //       }

  //       // Replace class selectors with prefixed versions
  //       trimmed = trimmed.replace(/\.(\w[\w-]*)/g, `.${className}-$1`);

  //       // Always add `.scm ` at the beginning for tag & id selectors
  //       return `#${prefClassName} ${trimmed}`;
  //     })
  //     .join(', ');

  //   return `${scopedSelectors} {`;
  // });
const noComments = isSet(cssString, '').toString().replace(/\/\*[\s\S]*?\*\//g, '');

// Split CSS into chunks: normal blocks vs @keyframes blocks
const parts = [];
let lastIndex = 0;

// Match @keyframes and @-webkit-keyframes blocks
const keyframesRegex = /@(-webkit-)?keyframes\s+[^{]+\{(?:[^{}]|\{[^{}]*\})*\}/g;
let match;

while ((match = keyframesRegex.exec(noComments)) !== null) {
  // Push CSS before keyframes (to be scoped)
  if (match.index > lastIndex) {
    parts.push({ type: 'css', content: noComments.slice(lastIndex, match.index) });
  }
  // Push the keyframes block (untouched)
  parts.push({ type: 'keyframes', content: match[0] });
  lastIndex = keyframesRegex.lastIndex;
}

// Push any remaining CSS after last keyframe
if (lastIndex < noComments.length) {
  parts.push({ type: 'css', content: noComments.slice(lastIndex) });
}

// Process only the normal CSS parts
const scopedParts = parts.map(part => {
  if (part.type === 'keyframes') return part.content; // untouched

  return part.content.replace(/([^\{\}]+)\s*\{/g, (match, selector) => {
    const trimmedSel = selector.trim();

    // Skip @media, @supports, etc.
    if (trimmedSel.startsWith('@')) {
      return match;
    }

    const scopedSelectors = selector
      .split(',')
      .map(s => {
        let trimmed = s.trim();

        // Skip if already prefixed
        if (trimmed.startsWith(`#${prefClassName}`)) {
          return trimmed;
        }

        // Replace class selectors
        trimmed = trimmed.replace(/\.(\w[\w-]*)/g, `.${className}-$1`);

        // Prefix tags and ids
        return `#${prefClassName} ${trimmed}`;
      })
      .join(', ');

    return `${scopedSelectors} {`;
  });
});

// Join everything back together
let result = scopedParts.join('');

// If isPreview is true, replace position: fixed with position: absolute
if (isPreview === true) {
  // Case-insensitive regex to match position: fixed (with various spacing)
  result = result.replace(/position\s*:\s*fixed/gi, 'position: absolute');
}

return result;


}

export const  isClassDefined =(className,inlineStyles,prefix='scm-')=> {
  
//   const selectorToCheck = `.${className}`;
//   if (className.startsWith(prefix)) return true; 
//   // Split CSS string into rules
//   const rules = inlineStyles.split("}");
//  // already prefixed
//   for (const rule of rules) {
//     const parts = rule.split("{");
//     // console.log('parts',parts);
//     if (parts.length < 2) continue; // skip invalid rules
    
//     const selText = parts[0].trim();
//     const selectors = selText.split(",");
//     // console.log('selectors',selectors);
//     // console.log('selectorToCheck',selectors,selectorToCheck);
//     for (const sel of selectors) {
//       if (sel.trim().includes(selectorToCheck)) {
//         return true; // class exists in CSS string
//       }
//     }
//   }
  //  // Already prefixed → skip
  // if (className.startsWith(prefix)) return true;
  // console.log('classNameExist',className);
  // // Split CSS into rules
  // const rules = inlineStyles.split("}");

  // for (const rule of rules) {
  //   const parts = rule.split("{");
  //   if (parts.length < 2) continue; // skip invalid rules

  //   const selText = parts[0].trim();
  //   const selectors = selText.split(",");

  //   for (const sel of selectors) {
  //     const trimmed = sel.trim();

  //     // Regex for exact class match
  //     // Matches: .btn, .btn:hover, .btn.active, .card > .btn
  //     // Does NOT match: .btn-flip, .flip-btn
  //     const regex = new RegExp(`(^|[\\s>+~])\\.${className}(?=$|[\\s.:#>,+~])`);

  //     if (regex.test(trimmed)) {
  //       console.log("className-ch", className, "matched in:", trimmed);
  //       return true;
  //     }
  //   }
  // }

  // console.log('inlineStyles',inlineStyles);
   const classRegex = /\.([a-zA-Z0-9_-]+)(?=[\s\.:,{])/g;
if (className.startsWith(prefix)) return true;
  let match;
  const classNames = new Set();

  while ((match = classRegex.exec(inlineStyles)) !== null) {
    classNames.add(match[1]);
  }

  return classNames.has(className);


  return false; // not found

}


export const prefixClassesForJS = (cssString, jsString, prefix)=>{
   // 1. Extract class names from CSS
  //  const classRegex = /\.([a-zA-Z0-9_-]+)/g;
  //   let match;
  //   const classNames = new Set();

  //   while ((match = classRegex.exec(cssString)) !== null) {
  //     classNames.add(match[1]);
  //   }

  //   // 2. Replace inside JS string
  //   let updatedJs = jsString;

  //   classNames.forEach(className => {
  //     const prefixed = `${prefix}-${className}`;

  //     // jQuery selectors $('.class')
  //     const jqSelectorRegex = new RegExp(
  //       `(['"\\s\\(\\[])\\.${className}([\\s'"])`,
  //       "g"
  //     );
  //     updatedJs = updatedJs.replace(jqSelectorRegex, `$1.${prefixed}$2`);

  //     // jQuery methods addClass/removeClass/toggleClass/hasClass
  //     const jqMethodRegex = new RegExp(
  //       `\\b(addClass|removeClass|toggleClass|hasClass)\\s*\\(\\s*(['"])${className}\\2\\)`,
  //       "g"
  //     );
  //     updatedJs = updatedJs.replace(jqMethodRegex, `$1($2${prefixed}$2)`);

  //     // Vanilla JS: getElementsByClassName("className")
  //     const getByClassRegex = new RegExp(
  //       `(getElementsByClassName\\s*\\(\\s*['"])${className}(['"]\\s*\\))`,
  //       "g"
  //     );
  //     updatedJs = updatedJs.replace(getByClassRegex, `$1${prefixed}$2`);

  //     // Vanilla JS: classList.add / remove / contains / toggle
  //     const classListRegex = new RegExp(
  //       `(classList\\.(add|remove|toggle|contains)\\s*\\(\\s*['"])${className}(['"]\\s*\\))`,
  //       "g"
  //     );
  //     updatedJs = updatedJs.replace(classListRegex, `$1${prefixed}$3`);
  //   });

  //   return updatedJs;

  
      // const classRegex = /\.([a-zA-Z0-9_-]+)/g;
      // let match;
      // const classNames = new Set();

      // while ((match = classRegex.exec(cssString)) !== null) {
      //   classNames.add(match[1]);
      // }
      const classRegex = /\.([a-zA-Z0-9_-]+)(?=[\s.:#>,+~{]|$)/g;
      let match;
      const classNames = new Set();

      while ((match = classRegex.exec(cssString)) !== null) {
        classNames.add(match[1]);
      }

      // console.log([...classNames]);
      // console.log('selectors1111',classNames);

      // 2. Replace inside JS string
      let updatedJs = jsString;

      classNames.forEach(className => {
        const prefixed = `${prefix}-${className}`;

        // jQuery selectors $('.class')
        // const jqSelectorRegex = new RegExp(
        //   `(['"\\s\\(\\[])\\.${className}([\\s'"])`,
        //   "g"
        // );
        // updatedJs = updatedJs.replace(jqSelectorRegex, `$1.${prefixed}$2`);

        //Fix: any selector (.a, .a.b, .a:b, etc.)
        const anySelectorRegex = new RegExp(
          `\\.${className}(?=[\\s'".,#:{>+\\]])`,
          "g"
        );
        updatedJs = updatedJs.replace(anySelectorRegex, `.${prefixed}`);

        // jQuery methods addClass/removeClass/toggleClass/hasClass
        const jqMethodRegex = new RegExp(
          `\\b(addClass|removeClass|toggleClass|hasClass)\\s*\\(\\s*(['"])${className}\\2\\)`,
          "g"
        );
        updatedJs = updatedJs.replace(jqMethodRegex, `$1($2${prefixed}$2)`);

        // Vanilla JS: getElementsByClassName("className")
        const getByClassRegex = new RegExp(
          `(getElementsByClassName\\s*\\(\\s*['"])${className}(['"]\\s*\\))`,
          "g"
        );
        updatedJs = updatedJs.replace(getByClassRegex, `$1${prefixed}$2`);

        // Vanilla JS: classList.add/remove/toggle/contains
        const classListRegex = new RegExp(
          `(classList\\.(add|remove|toggle|contains)\\s*\\(\\s*['"])${className}(['"]\\s*\\))`,
          "g"
        );
        updatedJs = updatedJs.replace(classListRegex, `$1${prefixed}$3`);

        // ✅ Template literals: `class1 ${var} class2`
        const templateRegex = new RegExp(
          "(`[^`]*?)\\b" + className + "\\b([^`]*?`)",
          "g"
        );
        updatedJs = updatedJs.replace(templateRegex, `$1${prefixed}$2`);
      });

     const domContentLoadedRegex = /document\.addEventListener\s*\(\s*['"]DOMContentLoaded['"]\s*,\s*(function\s*\(\s*\)|\(\s*\)\s*=>)\s*{/;

      if (domContentLoadedRegex.test(updatedJs)) {
        // console.log("domexists....");
        updatedJs = updatedJs.replace(
          domContentLoadedRegex,
          "$(document).ready(function() {"
        );
      }

      return updatedJs;
}


export const uniqueStr = (prefix = "scm-") =>{
  return prefix + Math.random().toString(36).substring(2, 6); // e.g., s1a2f
}


 export const extractOptions = (nodes,type) => {
  // console.log('sssss',nodes);
    // if (!node) return result;
    let options = [];
    if(type==='PickList'){
      options.push({id:'',value:'-None-'});
    }
    // else{
    //   options.push({value:'',label:'-None-'});
    // }
    nodes.forEach((node,index)=>{
      if(node.type==='tag' && node.name === 'option'){
         const textChild = node.children?.find(c => c.type === 'text');
         const label = textChild ? textChild.data.trim() : '';
        const value = node.attribs?.value || label;
        if(type==='PickList'){
          options.push({value: label,id:value  });
        }else{
          options.push({value: value,label:label,index:index  });
        }
        
      }
    })
    // if (node.type === 'tag' && node.name === 'option') {
    //   // Get the text inside the option
    //   const textChild = node.children?.find(c => c.type === 'text');
    //   const label = textChild ? textChild.data.trim() : '';
    //   const value = node.attribs?.value || label;

    //   result.push({ value, label });
    // }

    // // Recurse into children
    // if (Array.isArray(node.children)) {
    //   node.children.forEach(child => extractOptions(child, result));
    // }

    // // Recurse into siblings
    // if (node.next) {
    //   extractOptions(node.next, result);
    // }

    return options;
  };